import React, { Component } from 'react';

class GetResponse extends Component {
    constructor(props){
        super(props)
    }

    render(){

        let divstyle = { 'wordWrap': 'break-word' }

        return(
            <div className="ui divided three column grid">
                <div className="row">
                    <div className="column">
                    </div>
                    <div className="ui column segment" >
                        <div className="ui center aligned container" style={divstyle}>
                            <code>
                                {Object.entries(this.props.data.response).map(function(key, index) {
                                    if(key[1] === null){
                                        key[1] = "null"
                                    }
                                    return(<p key={index}><a>"{key[0]}" : "{key[1].toString()}"</a></p>)
                                    })}                              
                            </code>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default GetResponse



// WEBPACK FOOTER //
// ./src/components/Protected/Response/GetResponse.js